module.exports = __webpack_public_path__ + "static/media/homeDeliveryLogo.f3d6d146.png";